import { SUPPLIER_MANAGEMENT } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { ISupplierManagementRepository } from "features/supplierManagement/domain/repositories/ISupplierManagementRepository";
import { injectable } from "tsyringe";
import { CreateSupplierRequestModel } from "./model/create/CreateSupplierRequestModel";
import { SupplierDetailResponseModel } from "./model/detail/SupplierDetailResponseModel";
import { SupplierResponseModel } from "./model/SupplierResponseModel";
import { SupplierRequestModel } from "./model/SupplierResquestModel";
import { UpdateSupplierRequestModel } from "./model/update/UpdateSupplierRequestModel";

@injectable()
export class SupplierManagementImpl implements ISupplierManagementRepository {
  async getList(
    params: SupplierRequestModel,
  ): Promise<ListBaseApiResponseModel<SupplierResponseModel>> {
    return await client?.get(SUPPLIER_MANAGEMENT.LIST, params);
  }

  async getB2BSupplierList(
    params: SupplierRequestModel,
  ): Promise<ListBaseApiResponseModel<SupplierResponseModel>> {
    return await client?.get(SUPPLIER_MANAGEMENT.B2B_SUPPLIER_LIST, params);
  }

  async getDetail(params: {
    id: string;
  }): Promise<BaseApiResponseModel<SupplierDetailResponseModel>> {
    return await client?.get(SUPPLIER_MANAGEMENT.DETAIL, params);
  }

  async updateSupplier(
    body: UpdateSupplierRequestModel,
  ): Promise<BaseApiResponseModel<SupplierResponseModel>> {
    return await client?.put(SUPPLIER_MANAGEMENT.UPDATE, body);
  }

  async createSupplier(
    body: CreateSupplierRequestModel,
  ): Promise<BaseApiResponseModel<SupplierResponseModel>> {
    return await client?.post(SUPPLIER_MANAGEMENT.CREATE, body);
  }

  async deleteSupplier(params: {
    id: string;
  }): Promise<BaseApiResponseModel<SupplierResponseModel>> {
    return await client?.delete(SUPPLIER_MANAGEMENT.DELETE, params);
  }
}
